package com.macrofocus.nastac.components

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.nastac.ViewStyle
import i18next.useTranslation
import mui.material.Box
import mui.material.List
import mui.system.sx
import org.mkui.react.toState
import react.FC
import react.PropsWithChildren
import react.dom.html.ReactHTML.div
import web.cssom.px

external interface ViewStyleCustomProps : PropsWithChildren {
    var viewStyleProbing: MutableProperty<ViewStyle?>
    var viewStyleSelection: MutableProperty<ViewStyle>
    var viewStyleExpansion: MutableProperty<ViewStyle>
}

val ViewStyleCustom = FC<ViewStyleCustomProps> { props ->
    val (t, _) = useTranslation()

    val (viewStyle, setViewStyle) = props.viewStyleSelection.toState()

    List {
        dense = true
        sx {
            padding = 0.px
//            width = Sizes.Fabbar.Width
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.INTRO
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.GEOGRAPHY
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.CSHAPES
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.HEG
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.RSHAPES
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.PSPM
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        Box {
            component = div
            sx {
                height = 8.px
            }
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.TILLY
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.GEOPOLITICS
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.GEOPOLITICS_EXCL
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.GEOPOLITICS_KIN
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }

        Box {
            component = div
            sx {
                height = 8.px
            }
        }

        ViewStyleAccordion {
            this.viewStyle = ViewStyle.REPLICATION
            this.viewStyleProbing = props.viewStyleProbing
            this.viewStyleSelection = props.viewStyleSelection
            this.viewStyleExpansion = props.viewStyleExpansion
        }
    }
}